export const showingTime = [
    {
        value: "15 minutes"
    },
    {
        value: "30 minutes"
    },
    {
        value: "45 minutes"
    },
    {
        value: "1 hour"
    },
];

export const duration = [
    {
        value: "30 minutes"
    },
    {
        value: "1 hour"
    },
    {
        value: "2 hour"
    },
    {
        value: "3 hour"
    },
    {
        value: "4 hour"
    },
    {
        value: "5 hour"
    },
    {
        value: "6 hour"
    },
];